import React from 'react';
import ReactDOM from 'react-dom/client';
import { HashRouter } from 'react-router-dom';
import App from './App';
import './styles.css';

/**
 * HashRouter, not BrowserRouter.
 *
 * The build is static files served by nginx, and BrowserRouter needs every path
 * rewritten to index.html. That works until the same bundle is dropped behind a
 * /demo/ location on the central edge, or onto S3, and deep links start 404ing
 * with no obvious cause. A hash route needs no server cooperation at all.
 */
ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <HashRouter>
      <App />
    </HashRouter>
  </React.StrictMode>
);
